import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";
import STSComponent from "../../components/STSComponent/STSComponent";
import { globals } from '../../globals';
import Cookies from 'universal-cookie';
import { withRouter } from 'react-router-dom';
import { logInTk } from "../../store/reducers/auth";
import "./css/RSignOn.scss";

class RSignOn extends STSComponent {
  constructor(props) {
    super(props);

    this.urlSearch = window.location.search;
    window.localStorage.clear();

    this.state = {
      ax: null,
      yd: null,
      vc: null,
      isChecked: false,
      signInClicked: false,
    };

    this.signIn = this.signIn.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      if (nextProps.successLogin && !nextProps.isLoggingIn){
        console.log('go to ssignon');
        this.props.history.push("/ssignon");
      }
     }   
  }

  signIn = (ax, yd, vc) => {
    this.props.logInTk(ax, yd, vc);
    this.setState({ signInClicked: true });
  };

  componentDidMount() {
    if (this.urlSearch) {
      var searchParams = new URLSearchParams(this.urlSearch);    

      // report variables may be passed in from unathenticated users 
      // accessing the services website. 
      const ax = searchParams.get("ax");
      const yd = searchParams.get("yd");
      const vc = searchParams.get("vc");

      this.setState({ ax: ax });
      this.setState({ yd: yd });
      this.setState({ vc: vc });

      // check whether a specific destination should be specified 
      // rather than allowing the user to be sent to the 
      // root (see ssignon for ex)
      if(ax && yd && vc){
        console.log('submit rso auth.');
        // perform logintk
        this.signIn(ax, yd, vc)
        // .then((json) => {
        //   let xx = json;
        //   this.props.history.push("/ssignon");
        // });

      } else {
        console.log('required rso values not found.');
        //this.props.history.push("/login");        
      }
     }
  }

  render() {
    const { ax, yd, vc } = this.state;
    console.log('rso render.');
    return <Fragment>
            <div className="text-center viewport-layout">
              <div className="fixed-block z-index">
              </div>
              <div className={`container custom-content-container text-center `}>
                <div className="page-layout-viewport">
                <div className="rso-body"><br></br><div>Initializing...</div></div>
                </div>
              </div>
            </div>
      </Fragment>    
  }

  static propTypes = {
    logInTk: PropTypes.func,
    isLoggingIn: PropTypes.bool,
    successLogin: PropTypes.bool,
  };
}

const mapDispatchToProps = {
  logInTk,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isLoggingIn: state.auth.isLoggingIn,
  successLogin: state.auth.successLogin,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RSignOn));




// WEBPACK FOOTER //
// ./src/routes/RSignOn/RSignOn.js